(ns common.schema.entities.kyc.kyc-profile.schema
  (:require [clojure.string :as string]
            [common.country :as country]
            [common.data-types :as data-types]
            [common.schema.entities.kyc.kyc-profile.materialization :as materialization]
            [common.schema.entities.kyc.options :as kyc-options]
            [common.schema.entities.workspace.kyc.templates.templates :as templates]
            [common.schema.option-filters :as option-filters]
            [common.schema.schema-utils :as su]))

(def schema
  (vec
   (concat
    (su/text-simple-field :kyc-profile/name
                          "Name"
                          {:composite-attributes     [:kyc-profile/target]
                           :name-attribute           :kyc-profile/name
                           :calculation-triggers     {:entity.type/investor [[:kyc-profile/_target]]}
                           :editor-type              :editor.type/none
                           :default-field-visibility :in-use})
    (su/single-ref-field :kyc-profile/target
                         "Investor"
                         [:entity.type/investor]
                         {:mandatory-config         :mandatory/always
                          :deep-indexing?           true
                          :system-required?         true
                          :system-semantics
                          su/user-provided-system-required-field-semantics
                          :default-field-visibility :in-use})
    (su/keyword-multi-field :kyc-profile/tax-countries
                            "Tax environments"
                            country/options
                            {:default-field-visibility :in-use})
    (su/keyword-field :kyc-profile/status
                      "Status"
                      kyc-options/status-options
                      {:default-field-visibility :in-use})
    (su/datetime-field :kyc-profile/next-deadline
                       "Next deadline"
                       {:default-field-visibility :in-use})
    (su/datetime-field :kyc-profile/approval-date
                       "Approval date"
                       {:default-field-visibility :in-use})
    (su/single-ref-field :kyc-profile/our-contact
                         "Our contact"
                         [:entity.type/account]
                         {:option-filter-fn         option-filters/active-users
                          :os-filter-terms-fn       (fn [{:keys []}]
                                                      {"extras.active-user" true})
                          :default-field-visibility :in-use})
    (su/single-ref-field :kyc-profile/our-kyc-contact
                         "Our KYC contact"
                         [:entity.type/account]
                         {:option-filter-fn         option-filters/active-users
                          :os-filter-terms-fn       (fn [{:keys []}]
                                                      {"extras.active-user" true})
                          :default-field-visibility :in-use})
    (su/single-ref-field :kyc-profile/their-contact
                         "Their contact"
                         [:entity.type/person]
                         {:default-field-visibility :in-use})
    (su/single-ref-field :kyc-profile/their-kyc-contact
                         "Their KYC contact"
                         [:entity.type/person]
                         {:default-field-visibility :in-use})

    (su/keyword-field :kyc-profile/kyc-country
                      "Jurisdiction"
                      country/options
                      {:default-field-visibility :in-use})

    (su/option-field :kyc-profile/investor-classification
                     "Investor classification"
                     {:default-field-visibility :in-use})

      ;; TODO: Mark as removed in db once migration completed
    #_(su/boolean-field :kyc-profile/blocked
                        "Blocked"
                        {:authorization            su/access-user-user
                         :default-field-visibility :in-use})

    (su/keyword-field :kyc-profile/blocking-status
                      "Blocking configuration"
                      kyc-options/blocking-status-options
                      {:default-field-visibility :in-use
                       :authorization            su/access-user-user})

    (su/calculated-field :kyc-profile/calc-blocking-status
                         "Blocking status"
                         {:default-field-visibility :in-use
                          :value-type               :keyword
                          :data-type                :data.type/keyword
                          :options                  [{:key   :blocking-status/blocked
                                                      :value :blocking-status/blocked
                                                      :label "Blocked"}
                                                     {:key   :blocking-status/not-blocked
                                                      :value :blocking-status/not-blocked
                                                      :label "Not blocked"}]
                          :calc-fn                  materialization/calc-blocking-status-fn
                          :composite-attrs          [:kyc-profile/approval-date :kyc-profile/risk-category]
                          :calculation-triggers     {:entity.type/kyc-risk-category [[:kyc-profile/_risk-category]]
                                                     :entity.type/screening-profile [[:screening-profile/kyc-profiles]]}})

    (su/single-ref-field :kyc-profile/risk-category
                         "KYC category"
                         [:entity.type/kyc-risk-category]
                         {:create-on-fly?           true
                          :authorization            {:access/create :role/user}
                          :default-field-visibility :in-use})
    (su/datetime-field :kyc-profile/risk-category-changed-on
                       "Risk category changed on"
                       {:editor-type              :editor.type/none
                        :grid-type                :editor.type/none
                        :filter-type              :editor.type/none
                        :default-field-visibility :in-use})
    (su/multi-ref-field :kyc-profile/kyc-processes
                        "KYC processes"
                        [:entity.type/kyc-process]
                        {:editor-type              :editor.type/none
                         :grid-type                :editor.type/none
                         :filter-type              :filter.type/none
                         :default-field-visibility :in-use})
    (su/option-field :kyc-profile/ubo-validation "UBO validation" {:default-field-visibility :in-use})

    (su/keyword-field :kyc-profile/screening-status
                      "Screening status"
                      [{:key :screening-status/auto :label "Auto"}
                       {:key :screening-status/enforced :label "Enforced"}
                       {:key :screening-status/suspended :label "Suspended"}]
                      {:authorization              su/access-user-user
                       :default-field-visibility :in-use
                       :not-clearable?             true
                       :field-in-use-filter        (fn [_entity _entity-types-lookup
                                                        has-feature-access-fn _has-entity-access?]
                                                     (has-feature-access-fn :feature/screening))
                       :hidden-from-configuration? true})
    (su/keyword-field :kyc-profile/customer-status
                      "Customer status"
                      [{:key :customer-status/active :label "Active"}
                       {:key :customer-status/passive :label "Passive"}
                       {:key :customer-status/terminated :label "Terminated"}
                       {:key :customer-status/prospect :label "Prospect"}]
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use})

    (su/date-field :kyc-profile/termination-date "Termination date"
                   {:authorization            su/access-user-user
                    :default-field-visibility :in-use})

      ;; Block for now since not used
    (su/boolean-field :kyc-profile/automated-renewal-enabled?
                      "Automated renewal enabled?"
                      {:authorization            su/access-system-system
                       :default-field-visibility :not-in-use-blocked})

    (su/boolean-field :kyc-profile/auto-reminders-enabled?
                      "Auto reminders enabled?"
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use
                       :field-in-use-filter      (fn [_entity
                                                      _entity-types-lookup
                                                      has-feature-access-fn
                                                      _has-entity-access?]
                                                   (has-feature-access-fn :feature/automated-kyc-renewal))})

      ;; Block for now since not used
    (su/date-field :kyc-profile/next-renewal-start-date
                   "Next renewal start date"
                   {:authorization            su/access-system-system
                    :default-field-visibility :not-in-use-blocked})

    (su/calculated-field :kyc-profile/active-in-administrator-funds
                         "Active in administrator funds"
                         {:data-type                :data.type/text-simple
                          :calculation-triggers     {:entity.type/investor        [[:kyc-profile/_target]]
                                                     :entity.type/fund-commitment [[:fund-commitment/investor :kyc-profile/_target]]
                                                     :entity.type/fund            [[:fund-commitment/_fund :fund-commitment/investor :kyc-profile/_target]]}
                          :composite-attrs          [:fund-commitment/fund :kyc-profile/target :fund-commitment/investor
                                                     :fund-commitment/exit-date :fund/external-kyc-tool]
                          :default-field-visibility :in-use
                          :calc-fn                  (fn [{:keys [entity-data entity-lookup reverse-lookup]}]
                                                      (let [target-id (:kyc-profile/target entity-data)
                                                            target (entity-lookup target-id)
                                                            target-commitments (reverse-lookup
                                                                                {:entity                 target
                                                                                 :attribute-entity-types [:entity.type/fund-commitment]
                                                                                 :attribute              :fund-commitment/investor})
                                                            active-commitments (->> target-commitments
                                                                                    (keep entity-lookup)
                                                                                    (remove :fund-commitment/exit-date))
                                                            funds-with-external-kyc (->> active-commitments
                                                                                         (map :fund-commitment/fund)
                                                                                         (distinct)
                                                                                         (keep entity-lookup)
                                                                                         (remove :fund/date-liquidation-date)
                                                                                         (filter :fund/external-kyc-tool))]
                                                        (->> funds-with-external-kyc
                                                             (map :fund/name)
                                                             (string/join "; "))))})

    [[:kyc-profile/calculated-deadline
      {:field/data-type             :data.type/datetime
       :field/default-visibility    {:editor           :editor.type/date
                                     :grid             :editor.type/date
                                     :filter           :filter.type/date
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/system}
       :field/composite-attributes  [:kyc-profile/approval-date :kyc-profile/risk-category]
       :calculation-triggers        {:entity.type/kyc-risk-category [[:kyc-profile/_risk-category]]}
       :field/calculated-field      (fn [{:keys [entity-data entity-lookup]}]
                                      (let [risk-category-id (:kyc-profile/risk-category
                                                              entity-data)
                                            risk-category (entity-lookup risk-category-id)
                                            expiry-epoch (materialization/kyc-profile-expires-epoch entity-data risk-category)]
                                        expiry-epoch))
       :field/translations          {:en "Renewal deadline"}}]]
    [[:kyc-profile/latest-process-status
      {:field/data-type             :data.type/keyword
       :value-type                  :keyword
       :field/default-visibility    {:editor           :editor.type/none
                                     :grid             :editor.type/select
                                     :filter           :filter.type/select
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/system}
       :field/composite-attributes  [:kyc-process/status :kyc-profile/kyc-processes]
       :calculation-triggers        {:entity.type/kyc-process [[:kyc-profile/_kyc-processes]]}
       :field/calculated-field      (fn [{:keys [entity-data entity-lookup]}]
                                      (let [processes (get entity-data :kyc-profile/kyc-processes)
                                            latest-process (->> processes
                                                                (keep entity-lookup)
                                                                (remove :common/disabled?)
                                                                (sort-by :common/created-on)
                                                                (last))]
                                        (:kyc-process/status latest-process)))
       :options                     kyc-options/process-status-options
       :field/translations          {:en "Latest process status"}}]
     [:kyc-profile/latest-recorded-pep-count
      {:field/data-type             :data.type/integer
       :field/default-visibility    {:editor           :editor.type/none
                                     :grid             :editor.type/integer
                                     :filter           :filter.type/integer
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/system}
       :field/composite-attributes  [:kyc-profile/kyc-processes :kyc-process/status
                                     :kyc-process/answers]
       :calculation-triggers        {:entity.type/kyc-process [[:kyc-profile/_kyc-processes]]}
       :field/calculated-field      (fn [{:keys [entity-data entity-lookup]}]
                                      (let [processes (get entity-data :kyc-profile/kyc-processes)
                                            latest-approved-process
                                            (->> processes
                                                 (keep entity-lookup)
                                                 (remove :common/disabled?)
                                                 (filter (fn [proc]
                                                           (contains?
                                                            #{:kyc-process.status/approved-modified
                                                              :kyc-process.status/approved}
                                                            (:kyc-process/status proc))))
                                                 (sort-by :common/created-on)
                                                 (last))
                                            answers (:kyc-process/answers latest-approved-process)
                                            answers (if (string? answers)
                                                      (data-types/parse-edn-string answers)
                                                      answers)
                                            pep-attribute (->> answers
                                                               (keys)
                                                               (some #{:kyc-person/pep-edn
                                                                       :kyc-legal-entity/pep-edn}))
                                            pep-data (get answers pep-attribute)
                                            pep-data (if (string? pep-data)
                                                       (data-types/parse-edn-string pep-data)
                                                       pep-data)]
                                        (count pep-data)))
       :field/translations          {:en "Number of PEPs"}}]
     [:kyc-profile/latest-approved-board-member-count
      {:field/data-type             :data.type/integer
       :field/default-visibility    {:editor           :editor.type/none
                                     :grid             :editor.type/integer
                                     :filter           :filter.type/integer
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/system}
       :field/composite-attributes  [:kyc-profile/kyc-processes :kyc-process/status
                                     :kyc-process/answers]
       :calculation-triggers        {:entity.type/kyc-process [[:kyc-profile/_kyc-processes]]}
       :field/calculated-field
       (fn [{:keys [entity-data entity-lookup]}]
         (let [processes (get entity-data :kyc-profile/kyc-processes)
               latest-approved-process (->> processes
                                            (keep entity-lookup)
                                            (remove :common/disabled?)
                                            (filter (fn [proc]
                                                      (contains?
                                                       #{:kyc-process.status/approved-modified
                                                         :kyc-process.status/approved}
                                                       (:kyc-process/status proc))))
                                            (sort-by :common/created-on)
                                            (last))
               answers (:kyc-process/answers latest-approved-process)
               answers (if (string? answers)
                         (data-types/parse-edn-string answers)
                         answers)
               board-member-attribute (->> answers
                                           (keys)
                                           (some #{:kyc-person/board-members-edn
                                                   :kyc-legal-entity/board-members-edn}))
               board-member-data (get answers board-member-attribute)
               board-member-data (if (string? board-member-data)
                                   (data-types/parse-edn-string board-member-data)
                                   board-member-data)
               board-members-approved-by-customer
               (->> board-member-data
                    (filter (fn [board-member]
                              (= (:kyc-board-member/confirmation-status board-member)
                                 :confirmed-by-customer))))]
           (count board-members-approved-by-customer)))
       :field/translations          {:en "Number of board members"}}]
     [:kyc-profile/latest-approved-ubo-count
      {:field/data-type             :data.type/integer
       :field/default-visibility    {:editor           :editor.type/none
                                     :grid             :editor.type/integer
                                     :filter           :filter.type/integer
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/system}
       :field/composite-attributes  [:kyc-profile/kyc-processes :kyc-process/status
                                     :kyc-process/answers]
       :calculation-triggers        {:entity.type/kyc-process [[:kyc-profile/_kyc-processes]]}
       :field/calculated-field      (fn [{:keys [entity-data entity-lookup]}]
                                      (let [processes (get entity-data :kyc-profile/kyc-processes)
                                            latest-approved-process
                                            (->> processes
                                                 (keep entity-lookup)
                                                 (remove :common/disabled?)
                                                 (filter (fn [proc]
                                                           (contains?
                                                            #{:kyc-process.status/approved-modified
                                                              :kyc-process.status/approved}
                                                            (:kyc-process/status proc))))
                                                 (sort-by :common/created-on)
                                                 (last))
                                            answers (:kyc-process/answers latest-approved-process)
                                            answers (if (string? answers)
                                                      (data-types/parse-edn-string answers)
                                                      answers)
                                            ubo-attribute (->> answers
                                                               (keys)
                                                               (some #{:kyc-person/ubo-edn
                                                                       :kyc-legal-entity/ubo-edn}))
                                            ubo-data (get answers ubo-attribute)
                                            ubo-data (if (string? ubo-data)
                                                       (data-types/parse-edn-string ubo-data)
                                                       ubo-data)]
                                        (count ubo-data)))
       :field/translations          {:en "Number of UBOs"}}]
     [:kyc-profile/number-of-active-commitments
      {:field/data-type             :data.type/text
       :field/default-visibility    {:editor           :editor.type/none
                                     :grid             :editor.type/text-simple
                                     :filter           :filter.type/text
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/system}
       :field/composite-attributes  [:fund-commitment/investor :fund-commitment/exit-date
                                     :fund/date-liquidation-date]
       :calculation-triggers        {:entity.type/investor        [[:kyc-profile/_target]]
                                     :entity.type/fund-commitment [[:fund-commitment/investor :kyc-profile/_target]]
                                     :entity.type/fund            [[:fund-commitment/_fund :fund-commitment/investor :kyc-profile/_target]]}
       :field/calculated-field      (fn [{:keys [entity-data entity-lookup reverse-lookup]}]
                                      (let [target-id (:kyc-profile/target entity-data)
                                            target (entity-lookup target-id)
                                            target-commitments (reverse-lookup
                                                                {:entity                 target
                                                                 :attribute-entity-types [:entity.type/fund-commitment]
                                                                 :attribute              :fund-commitment/investor})
                                            active-commitments (->> target-commitments
                                                                    (keep entity-lookup)
                                                                    (remove :common/disabled?)
                                                                    (remove :fund-commitment/exit-date))
                                            active-funds (->> active-commitments
                                                              (map :fund-commitment/fund)
                                                              (distinct)
                                                              (keep entity-lookup)
                                                              (remove :common/disabled?)
                                                              (remove :fund/date-liquidation-date)
                                                                ; Request by CapMan - if external kyc tool, do not show in this list
                                                              (remove :fund/external-kyc-tool))]
                                        (->> active-funds
                                             (map :fund/name)
                                             (string/join "; "))))
       :field/translations          {:en "Active in funds"}}]
     [:kyc-profile/number-of-active-agreements
      {:field/data-type             :data.type/integer
       :field/default-visibility    {:editor           :editor.type/none
                                     :grid             :editor.type/integer
                                     :filter           :filter.type/integer
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/system}
       :field/composite-attributes  [:kyc-profile/target :sale-agreement/customer
                                     :sale-agreement/contract-end-date]
       :calculation-triggers        {:entity.type/investor       [[:kyc-profile/_target]]
                                     :entity.type/sale-agreement [[:sale-agreement/customer :kyc-profile/_target]]}
       :field/calculated-field      (fn [{:keys [entity-data entity-lookup reverse-lookup]}]
                                      (let [target-id (:kyc-profile/target entity-data)
                                            target (entity-lookup target-id)
                                            target-agreements (reverse-lookup
                                                               {:entity                 target
                                                                :attribute-entity-types [:entity.type/sale-agreement]
                                                                :attribute              :sale-agreement/customer})
                                            active-agreements (->> target-agreements
                                                                   (keep entity-lookup)
                                                                   (remove :common/disabled?)
                                                                   (remove :sale-agreement/contract-end-date))]
                                        (count active-agreements)))
       :field/translations          {:en "Number of active agreements"}}]
     [:kyc-profile/professional-investor?
      {:field/data-type             :data.type/boolean
       :field/default-visibility    {:editor           :editor.type/none
                                     :grid             :editor.type/checkbox
                                     :filter           :filter.type/boolean
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/system}
       :field/composite-attributes  [:kyc-profile/kyc-processes :kyc-process/status
                                     :kyc-process/template :kyc-process/answers]
       :calculation-triggers        {:entity.type/kyc-process [[:kyc-profile/_kyc-processes]]}
       :field/calculated-field      (fn [{:keys [entity-data entity-lookup]}]
                                      (let [processes (get entity-data :kyc-profile/kyc-processes)
                                            latest-approved-process (->> processes
                                                                         (keep entity-lookup)
                                                                         (remove :common/disabled?)
                                                                         (filter (fn [proc]
                                                                                   (contains?
                                                                                    #{:kyc-process.status/approved-modified :kyc-process.status/approved}
                                                                                    (:kyc-process/status proc))))
                                                                         (sort-by :common/created-on)
                                                                         (last))
                                            answers (data-types/parse-edn-string (:kyc-process/answers latest-approved-process))]
                                        (= :yes
                                           (if (templates/natural-person-templates-keys
                                                (:kyc-process/template latest-approved-process))
                                             (:kyc-person/professional-investor? answers)
                                             (:kyc-legal-entity/professional-investor? answers)))))
       :field/translations          {:en "Professional investor?"}}]
     [:kyc-profile/datetime-last-invitation
      {:field/data-type             :data.type/datetime
       :field/default-visibility    {:editor           :editor.type/none
                                     :grid             :editor.type/datetime
                                     :filter           :filter.type/date
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/system}
       :field/composite-attributes  [:kyc-profile/kyc-processes :kyc-process/invited-date]
       :calculation-triggers        {:entity.type/kyc-process [[:kyc-profile/_kyc-processes]]}
       :field/calculated-field      (fn [{:keys [entity-data entity-lookup]}]
                                      (let [processes (get entity-data :kyc-profile/kyc-processes)
                                            latest-invite-datetime (->> processes
                                                                        (keep entity-lookup)
                                                                        (remove :common/disabled?)
                                                                        (keep
                                                                         :kyc-process/invited-date)
                                                                        (sort)
                                                                        (last))]
                                        latest-invite-datetime))
       :field/translations          {:en "Last invitation sent"}}]])))
